import * as types from '../mutation-types'
import userService from '../../services/userroles'

const state = {
    loading: false,
    errors: '',
    userroles: []
}

const actions = {
    getAll({ commit },data) {
        commit(types.USERROLE_LOADING, true)
        userService.getAll(data).then(
            response => {

                commit(types.LOAD_USERROLES, response.data)
                commit(types.USERROLE_LOADING, false)
            },
            error => {
                commit(types.USERROLE_FAILURE, error)
                commit(types.USERROLE_LOADING, false)
            }
        )
    },
    add({ commit }, data) {
        commit(types.USERROLE_LOADING, true)
        commit(types.USERROLE_FAILURE, null)
        userService.add(data).then(
            response => {
                data.id = response.data.id
                commit(types.ADD_USERROLE, data)
                commit(types.USERROLE_LOADING, false)
            },
            error => {
                commit(types.USERROLE_FAILURE, error)
                commit(types.USERROLE_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.USERROLE_LOADING, true)
        commit(types.USERROLE_FAILURE, null)
        userService.update(data.user_role)
            .then(
                response => {
                    commit(types.UPDATE_USERROLE, data)
                    commit(types.USERROLE_LOADING, false)
                },
                error => {
                    commit(types.USERROLE_FAILURE, error)
                    commit(types.USERROLE_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.USERROLE_LOADING, true)
        commit(types.USERROLE_FAILURE, null)
        userService.delete(data.user_role.id)
            .then(
                response => {

                    commit(types.DELETE_USERROLE, data)
                    commit(types.USERROLE_LOADING, false)
                },
                error => {
                    commit(types.USERROLE_FAILURE, error)
                    commit(types.USERROLE_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_USERROLE](state, payload) {
        state.userroles.unshift(payload);
    },
    [types.LOAD_USERROLES](state, payload) {
        state.userroles = payload
    },
    [types.UPDATE_USERROLE](state, payload) {
        Object.assign(state.userroles[payload.index], payload.user);
    },
    [types.DELETE_USERROLE](state, payload) {
        state.userroles.splice(payload.index, 1)
    },
    [types.USERROLE_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.USERROLE_LOADING](state, payload) {
        state.loading = payload
    },
}


const getters = {
    USERROLES: state => {
        return state.userroles
    },

    USERROLE_ERROR: state => {
        return state.errors
    },

    USERROLE_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/userroles.js